const state = {
    novelties: {},
    loading: false
};

export default state;